<template>
  <div class="page">
    <div class="searchView">
      <div class="tabLine">
        <div class="tabItem" :class="[activeIndex == '' ? 'active' : '']" @click="handleSelect('')">全部订单</div>
        <div class="tabItem" :class="[activeIndex == '1' ? 'active' : '']" @click="handleSelect('1')">商品订单</div>
        <div class="tabItem" :class="[activeIndex == '3,4,5,7' ? 'active' : '']" @click="handleSelect('3,4,5,7')">医疗订单
        </div>
        <div class="tabItem" :class="[activeIndex == '2' ? 'active' : '']" @click="handleSelect('2')">洗美订单</div>
        <div class="tabItem" :class="[activeIndex == '6' ? 'active' : '']" @click="handleSelect('6')">寄养订单</div>
        <div class="tabItem" :class="[activeIndex == '8' ? 'active' : '']" @click="handleSelect('8')">活体订单</div>
        <div class="tabItem" :class="[activeIndex == '9' ? 'active' : '']" @click="handleSelect('9')">虚拟订单</div>
        <div class="tabItem" :class="[activeIndex == '10' ? 'active' : '']" @click="handleSelect('10')">订金订单</div>
      </div>
      <!-- 提交 -->
      <el-form class="searchBox">
        <el-row>
          <el-col :span="4">
            <el-form-item>
              <el-input style="width: 130px; margin-right: 10px" placeholder="请输入关键字" v-model="search.keyword" clearable
                @keyup.enter.native="changeSearch" size="small"></el-input>
              <el-button @click="changeSearch" type="warning" size="small">搜索</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="订单状态" :label-width="'60px'">
              <el-select style="width: 100px" class="select" v-model="search.state" @change="changeSearch"
                placeholder="请选择" size="small">
                <el-option v-for="item in [
                  { label: '已取消', value: '-2' },
                  { label: '全部', value: '' },
                  { label: '待支付', value: '1,2' },
                  { label: '支付成功', value: '3' },
                  { label: '退换中', value: '-3' },
                  { label: '退换成功', value: '-4' },
                ]" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="支付方式" :label-width="'70px'">
              <el-select style="width: 100px" class="select" v-model="search.pay_type" @change="changeSearch"
                placeholder="请选择" size="small">
                <el-option v-for="item in [
                  { label: '全部', value: '' },
                  { label: '现金', value: '0' },
                  { label: 'pos机', value: '5' },
                  { label: '余额', value: '7' },
                  { label: '拉卡拉', value: '17' },
                  { label: '电商平台', value: '11' },
                  { label: '优惠', value: '12' },
                  { label: '京东聚合', value: '13' },
                  { label: '嘉联', value: '15' },
                  { label: '押金', value: '10' },
                ]" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="销售人员" :label-width="'80px'">
              <el-select v-model="saleValue" filterable placeholder="请选择" style="width: 100px" @change="changeSearch"
                size="small">
                <el-option v-for="item in staffList" :key="item._id" :label="item.basic_info.real_name"
                  :value="item._id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="销售日期" :label-width="'90px'">
              <el-date-picker @change="changeSearch" v-model="datetimerange" type="daterange" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" size="small" style="width: 220px"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="text-align: right">
            <resetBtn @reset="reset" style="width: 56px; display: inline-block; margin: 0px 10px"></resetBtn>
            <el-button type="warning" @click="combinationOrder" size="small">合单支付</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 表格 -->
    <div class="pageConBox">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="no" label width="40">
          <template slot-scope="scope">
            <el-checkbox v-if="isCheckboxVisible(scope.row)" v-model="scope.row.checked"
              @change="checked_change(scope.row)"></el-checkbox>
            <el-checkbox v-else disabled></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column prop="no" label="销售订单" width="130"></el-table-column>
        <el-table-column label="类型" width="70">
          <template slot-scope="scope">
            {{ scope.row.order_type_id == 1 ? "商品" : "" }}
            {{ scope.row.order_type_id == 2 ? "洗美" : "" }}
            {{ scope.row.order_type_id == 3 ? "病例" : "" }}
            {{ scope.row.order_type_id == 4 ? "疫苗驱虫" : "" }}
            {{ scope.row.order_type_id == 5 ? "医疗服务" : "" }}
            {{ scope.row.order_type_id == 6 ? "寄养" : "" }}
            {{ scope.row.order_type_id == 7 ? "挂号" : "" }}
            {{ scope.row.order_type_id == 8 ? "活体" : "" }}
            {{ scope.row.order_type_id == 9 ? "虚拟类" : "" }}
            {{ scope.row.order_type_id == 10 ? "订金" : "" }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="顾客" width="160">
          <template slot-scope="scope">
            <div>
              <span style="cursor: pointer; color: #409eff" @click="
                $router.push({
                  path: '/huiyuan/huiyuanSee',
                  query: { id: scope.row.user_info.user_id },
                })
                ">{{ scope.row.user_info.nick_name }}</span>
              <span v-if="scope.row.user_info.user_mobile">({{ scope.row.user_info.user_mobile }})</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="宠物" width="80">
          <template slot-scope="scope">
            <div @click="
              toPetSee(scope.row.user_info.user_id, item.split('bind')[1])
              " style="cursor: pointer; color: #409eff" v-for="(item, index) in getPetList(scope.row.order_item_list)"
              :key="index">{{ item.split("bind")[0] }}</div>
          </template>
        </el-table-column>

        <el-table-column label="结算金额" width="90">
          <template slot-scope="scope">
            {{
              scope.row.total_price.toFixed(2)
            }}
          </template>
        </el-table-column>
        <el-table-column prop="zip" label="结算状态" width="70">
          <template slot-scope="scope">
            {{
              $public.formatOrderState(scope.row.state)
            }}
          </template>
        </el-table-column>
        <el-table-column prop="zip" label="结算方式">
          <template v-if="scope.row.pay_info" slot-scope="scope">
            <div v-for="(item, index) in scope.row.pay_info.pay_list" :key="index">
              <span style="padding-right: 2px">
                {{
                  $public.formatPayTypeState(item.pay_type)
                }}
              </span>
              {{ Math.abs(item.money.toFixed(2)) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="订单备注" width="70">
          <template slot-scope="scope">
            <el-popover placement="top-start" width="200" trigger="hover" :content="scope.row.remark">
              <div slot="reference" style="
                  width: 80px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  cursor: pointer;
                ">{{ scope.row.remark }}</div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="结算备注">
          <template v-if="scope.row.pay_info" slot-scope="scope">
            <el-popover placement="top-start" width="200" trigger="hover" :content="scope.row.pay_info.pay_remark">
              <div slot="reference" style="
                  width: 80px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  cursor: pointer;
                ">{{ scope.row.pay_info.pay_remark }}</div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="创建人" prop="create_manager_name"></el-table-column>
        <el-table-column label="创建日期" width="140">
          <template slot-scope="scope">
            {{
              $public.FTime(scope.row.create_time)
            }}
          </template>
        </el-table-column>
        <el-table-column label="发票状态" width="70">
          <template slot-scope="scope">
            {{
              scope.row.isHaveInvoices == true ? "已添加" : "未添加"
            }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="
              $router.push({
                path: '/dingdan/saleOrderSee',
                query: { id: scope.row._id, type: orderType },
              })
              " type="text" size="small">查看</el-button>
            <el-button v-if="is_jialian(scope.row) && scope.row.state === 2" @click="checkOrderState_Jialian(scope.row)"
              type="text" size="small">校验状态</el-button>
            <el-button v-if="scope.row.state == 3" type="text" size="small"
              @click="getInvoice(scope.row)">打印小票</el-button>
            <el-button v-if="scope.row.state == 1 || scope.row.state == 2" @click="edit(scope.row)" type="text"
              size="small">结算</el-button>
            <el-button v-if="scope.row.state == 3 && scope.row.buy_back_remind === 2" @click="
              curOrder = scope.row;
            dialogReBuy_state = true;
            " type="text" size="small">复购提醒</el-button>
            <el-button v-if="(scope.row.state == 1 || scope.row.state == 2) &&
              scope.row.state != -2
            " @click="cancel(scope.row._id)" type="text" size="small">取消</el-button>
            <el-button v-if="scope.row.state == -2" @click="del(scope.row._id)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row>
        <el-col>
          <div style="padding: 20px; font-size: 14px">本页合计：{{ totalMoney }}</div>
        </el-col>
      </el-row>
      <page :total="page.total" :page="page.page" @change="changePage" style="padding-bottom: 10px"></page>
    </div>
    <!-- 结算 -->
    <div v-if="dialogSettlementState">
      <dialogSettlement :type="settlement_type" :orderId="curOrder._id || curOrder.merge_order_no"
        :canYue="curOrder.business_param_code === 13 ? false : true" @submit="dialogSettlementSubmit">
      </dialogSettlement>
    </div>
    <!-- 合单 -->
    <el-dialog title="合单" :visible="dialogCombinationOrder_state" width="50%"
      @close="dialogCombinationOrder_state = false">
      <el-form>
        <!-- <el-form-item label="备注:" :label-width="'100px'">
					<el-input type="textarea" v-model="totalMoney"></el-input>
        </el-form-item>-->
        <el-form-item label="用户:" :label-width="'80px'">
          {{
            combinationOrder_list[0] &&
            combinationOrder_list[0].user_info.nick_name
          }}
          ({{
            combinationOrder_list[0] &&
            combinationOrder_list[0].user_info.user_mobile
          }})
        </el-form-item>
        <el-form-item label="合单列表:" :label-width="'80px'">
          <el-table class="table" :data="combinationOrder_list" style="width: 100%">
            <el-table-column prop="no" label="订单编号"></el-table-column>
            <el-table-column prop="no" label="宠物" width="150">
              <template slot-scope="scope">
                <div v-for="(item, index) in getPetList(scope.row.order_item_list)" :key="index">{{
                  item.split("bind")[0] }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="total_price" label="订单总金额"></el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCombinationOrder_state = false">取 消</el-button>
        <el-button type="primary" @click="dialogCombinationOrder_submit">确 定</el-button>
      </div>
    </el-dialog>
    <div v-if="dialogReBuy_state">
      <dialogReBuy :orderId="curOrder.no" @submit="submit_dialogReBuy"></dialogReBuy>
    </div>
    <!-- <iframe v-if="printUrl" :src="'ChuLinPrint:'+printUrl" width="0" height="0"></iframe> -->
  </div>
</template>
<script>
import page from "../../../../components/page.vue";
import dialogSettlement from "../../../../components/dialog_settlement.vue";
import resetBtn from "../../../../components/resetBtn.vue";
import dialogReBuy from "./dialogReBuy.vue";
import printJs from "../../../../util/print.js";
export default {
  components: {
    page,
    dialogSettlement,
    resetBtn,
    dialogReBuy
  },
  data() {
    return {
      sankeId: process.env.VUE_APP_sanke,
      orderType: "",
      search: {
        keyword: "",
        userid: "", // 用户id
        starttime: "",
        endtime: "",
        state: "", // 状态 -4：退款成功 -3：退款中 -2已取消 -1 全部  0：已删除  1：已创建  2：支付中 3 支付成功 4：已接单   5： 已发货    8：已完成
        pay_type: "" // 支付方式 -1 全部 0 现金 3 线下支付宝 4 线下微信 5 pos机 7 余额 8 赠额 9 积分
      },
      datetimerange: [],
      tableData: [],
      totalMoney: "", // 本页总金额
      page: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      curOrder: {},
      dialogSettlementState: false,
      // printUrl: '',
      // 合单
      settlement_type: "order",
      dialogCombinationOrder_state: false,
      combinationOrderId_arr: [],
      combinationOrder_list: [],
      activeIndex: "", //tab切换下标
      staffList: [], //员工列表
      saleValue: "", //销售人员

      // 复购
      dialogReBuy_state: false
    };
  },
  props: {},
  computed: {
    curShopId() {
      return this.$store.state.shopId;
    }
  },
  mounted() {
    this.getTableData();
    this.getStaffData();
  },
  methods: {
    //复选框状态
    isCheckboxVisible(scope) {
      return (
        (scope.state === 1 || scope.state === 2) &&
        scope.user_info.user_id !== this.sankeId &&
        !(
          scope.order_type_id === 8 && !this.$public.isNull(scope.other_param)
        ) &&
        (scope.order_type_id !== 2 ||
          !scope.order_item_list.some(item => {
            return (
              item.activity_info && item.activity_info.pay_type.includes("11")
            );
          }))
      );
    },

    //tab切换
    handleSelect(key) {
      this.activeIndex = key;
      this.page.page = 1;
      this.orderType = key;
      this.getTableData();
    },
    // 合单
    checked_change(row) {
      console.log(row, "row");
      let combinationOrderId_arr = JSON.parse(
        sessionStorage.getItem("combinationOrderId_arr") || "[]"
      );
      if (combinationOrderId_arr.indexOf(row.no) > -1) {
        combinationOrderId_arr.splice(
          combinationOrderId_arr.indexOf(row.no),
          1
        );
      } else {
        combinationOrderId_arr.push(row.no);
      }
      sessionStorage.setItem(
        "combinationOrderId_arr",
        JSON.stringify(combinationOrderId_arr)
      );
    },
    combinationOrder() {
      this.combinationOrderId_arr = JSON.parse(
        sessionStorage.getItem("combinationOrderId_arr") || "[]"
      );
      if (this.combinationOrderId_arr.length === 0) {
        this.$message({
          message: "请选择要合并的订单",
          type: "error"
        });
        return;
      }
      if (this.combinationOrderId_arr.length === 1) {
        this.$message({
          message: "单个订单不能执行合单支付",
          type: "error"
        });
        return;
      }
      let userid = "";
      this.combinationOrder_list = [];
      for (let i = 0; i < this.combinationOrderId_arr.length; i++) {
        let item = this.$public.getMatchingItem(
          this.tableData,
          "no",
          this.combinationOrderId_arr[i]
        );
        this.combinationOrder_list.push(item);
        if (i === 0) {
          userid = item.user_info.user_id;
        } else {
          if (userid !== item.user_info.user_id) {
            this.$message({
              message: "合单支付只能选择同一用户的订单",
              type: "error"
            });
            return;
          }
        }
      }
      // let arr_code = this.$public.sameCodeAtMergeOrder(
      //   this.combinationOrder_list
      // );
      // if (arr_code.length > 0) {
      //   this.$message({
      //     message:
      //       "合并订单中含有相同条码：" +
      //       arr_code.join(",") +
      //       "，不能进行合并操作！！",
      //     type: "error",
      //   });
      //   return;
      // }
      this.dialogCombinationOrder_state = true;
    },
    dialogCombinationOrder_submit() {
      let loading = this.$loading();
      this.$http
        .post("/api/Order/MergeOrder", this.combinationOrderId_arr)
        .then(res => {
          loading.close();
          if (res.code == 0) {
            this.settlement_type = "mergeOrder";
            this.curOrder = res.data;
            this.dialogCombinationOrder_state = false;
            this.dialogSettlementState = true;
            sessionStorage.setItem("combinationOrderId_arr", "[]");
          }
        });
    },
    // 跳转宠物详情
    toPetSee(a, b) {
      this.$router.push({
        path: "/huiyuan/huiyuanPetSee?uid=" + a + "&pid=" + b
      });
    },
    // 重置
    reset() {
      this.page.page = 1;
      this.search.keyword = "";
      this.search.starttime = "";
      this.search.endtime = "";
      this.datetimerange = [];
      this.search.state = "";
      this.search.pay_type = "";
      this.saleValue = "";
      this.getTableData();
    },
    //筛选变化
    changeSearch() {
      this.page.page = 1;
      this.getTableData();
    },
    // 改变分页
    changePage(num) {
      this.page.page = num;
      this.getTableData();
    },
    // 获取列表数据
    getTableData() {
      sessionStorage.setItem("combinationOrderId_arr", []);
      let loading = this.$loading();
      console.log("from表单", this.search);
      console.log("时间", this.datetimerange);
      let params = {
        keyword: this.search.keyword, //关键词
        userid: "", // 用户id
        pet_id: "", //宠物id
        starttime: "", //开始时间
        endtime: "", //结束时间
        pay_starttime: "", //支付开始时间
        pay_endtime: "", //支付结束时间
        state: this.search.state, //状态
        pay_type: this.search.pay_type, // 支付方式
        create_manager_id: "", //创建人id
        order_type: "", //订单类型
        order_type_id: this.orderType, //订单类型id
        sales_id: this.saleValue, //销售人员id
        shop_id: this.curShopId,
        page_index: this.page.page,
        page_size: this.page.pageSize,
        order_source: 2
      };

      if (this.datetimerange && this.datetimerange.length == 2) {
        params.starttime = (
          "" + new Date(this.datetimerange[0]).getTime()
        ).substr(0, 10);
        params.endtime = (
          "" + new Date(this.datetimerange[1]).getTime()
        ).substr(0, 10);
      }
      console.log(params.starttime, params.endtime);
      this.$http
        .post(process.env.VUE_APP_Url_order + "/api/CommonOrder/list", params)
        .then(res => {
          loading.close();
          if (res.code == 0) {
            let table = res.data.data;
            let combinationOrderId_arr = JSON.parse(
              sessionStorage.getItem("combinationOrderId_arr") || "[]"
            );
            for (let i = 0; i < table.length; i++) {
              if (combinationOrderId_arr.indexOf(table[i].no) > -1) {
                table[i].checked = true;
              } else {
                table[i].checked = false;
              }
            }
            this.tableData = res.data.data;
            this.page.total = res.data.count;
            this.getPageTotalMoney();
            console.log("订单列表", res.data.data);
          }
        });
    },
    // 复购
    submit_dialogReBuy(obj) {
      this.dialogReBuy_state = false;
      if (obj.type === "success") {
        this.getTableData();
      }
    },
    //获取员工列表
    getStaffData() {
      let params = {
        keyword: this.saleValue,
        pageIndex: 1,
        pageSize: 500
      };
      this.$http.get("/api/Staff/List", params).then(res => {
        console.log(res);
        if (res.code == 0) {
          this.staffList = res.data.data;
        }
      });
    },
    // 获取本页合计
    getPageTotalMoney() {
      let totalMoney = 0;
      for (let i = 0; i < this.tableData.length; i++) {
        totalMoney = totalMoney + this.tableData[i].total_price;
      }
      this.totalMoney = this.$public.toDoubleFixed2(totalMoney);
    },
    // 打印发票
    getInvoice(row) {
      this.$http
        .get("/api/Order/OrderReceipt", {
          orderNumber: row._id
        })
        .then(res => {
          if (res.code == 0) {
            let d = res.data;
            printJs.printTicketSaleOrder(d).then(r => {
              this.$store.commit("set_printUrl", r.msg);
              // if (r.url != '') {
              // 	this.printUrl = r.url;
              // 	setTimeout(() => {
              // 		this.printUrl = '';
              // 	}, 1000)
              // }
            });
          }
        });
    },
    // 结算
    edit(row) {
      console.log("订单111", row);
      if (row.order_type_id === 8 && !this.$public.isNull(row.other_param)) {
        this.settlement_type = "tailMoney";
        this.curOrder = row;
        this.dialogSettlementState = true;
      } else {
        this.settlement_type = "order";
        this.curOrder = row;
        this.dialogSettlementState = true;
      }
    },
    // 结算完成关闭弹窗 
    dialogSettlementSubmit(a) {
      this.dialogSettlementState = false;
      this.curOrder = {}; // 重置当前订单对象
      if (a == "close") {
        console.log(a);
      } else if (a == "fail") {
        this.$message({
          message: "结算失败",
          type: "error"
        });
      } else if (a == "success") {
        this.$message({
          message: "结算成功",
          type: "success"
        });
      }
      this.getTableData();
    },
    // 取消订单
    cancel(id) {
      this.$confirm("确定取消该订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http
          .get("/api/Order/ReceivedOrder", {
            order_id: id
          })
          .then(res => {
            if (res.code == 0) {
              this.$message({
                message: "取消成功",
                type: "success"
              });
              this.getTableData();
            }
          });
      });
    },
    // 删除已取消的订单
    del(id) {
      this.$confirm("确定删除该订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http
          .delete("/api/Order/DeleteOrder", {
            order_id: id
          })
          .then(res => {
            if (res.code == 0) {
              this.$message({
                message: "删除成功",
                type: "success"
              });
              this.getTableData();
            }
          });
      });
    },
    // 筛选订单包含的宠物
    getPetList(list) {
      let arr = [];
      for (let i = 0; i < list.length; i++) {
        if (list[i].pets_info) {
          if (
            arr.indexOf(
              list[i].pets_info.pets_name + "bind" + list[i].pets_info.pets_id
            ) === -1
          ) {
            arr.push(
              list[i].pets_info.pets_name + "bind" + list[i].pets_info.pets_id
            );
          }
        }
      }
      return arr;
    },
    // 嘉联
    is_jialian(row) {
      let payInfo = row.pay_info || { pay_list: [] };
      let money = 0;
      for (let i = 0; i < payInfo.pay_list.length; i++) {
        if (payInfo.pay_list[i].pay_type === 15) {
          money = payInfo.pay_list[i].money;
        }
      }
      if (money > 0) {
        return true;
      } else {
        return false;
      }
    },
    checkOrderState_Jialian(row) {
      this.$http
        .get("/api/pay/jl/payState", {
          shopId: this.curShopId,
          orderNum: row.no
        })
        .then(res => {
          if (res.code == 0) {
            if (res.data == "success") {
              this.$message({
                message: "该订单已支付，请刷新查看",
                type: "success"
              });
            } else {
              this.$message({
                message: res.info,
                type: "error"
              });
            }
          }
        });
    }
  }
};
</script>
<style scoped lang="scss">
.page {
  .searchView {
    ::v-deep .el-form-item {
      margin-bottom: 0;

      .el-form-item__label {
        padding-right: 5px;
        font-size: 12px;
      }
    }

    .tabLine {
      display: flex;

      .tabItem {
        width: 88px;
        box-sizing: border-box;
        line-height: 36px;
        text-align: center;
        border-right: 1px solid #f2f2f2;
        cursor: pointer;
        font-size: 14px;
        background-color: #fff;

        &.active {
          color: $mainColor;
        }
      }
    }

    .searchBox {
      border-top: 1px solid #f2f2f2;
    }
  }

  .pageConBox {
    padding: 0 0px;
    min-height: 600px;
  }
}
</style>
